import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "./localStorageService";
import { API_URL } from "../../config/config";

export const changePasApi = createApi({
  reducerPath: "changePasApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Accept", "application/json");
      getToken() != null &&
        headers.set("Authorization", `Bearer ${getToken()}`);
      return headers;
    },
  }), // Replace with your API URL
  endpoints: (builder) => ({
    changePass: builder.mutation({
      query: (newData) => ({
        url: "change-password", // Replace with your API endpoint
        method: "POST",
        body: newData,
      }),
    }),
  }),
});

export const { useChangePassMutation } = changePasApi;
